<template>
    <div class="animated fadeIn">
        <kgr-invoice-count-provider
            :club-id="clubId"
            :callback="onInvoiceCountLoaded"
        >
            <kgr-number-range-settings-provider
                v-slot="numberRangeSettingsScope"
                :club-id="clubId"
                :callback="onNumberRangeSettingsLoaded"
            >
                <kgr-form-scaffold
                    :pending="pending"
                    :with-back-button="false"
                    @primary-btn-clicked="updateSettings(numberRangeSettingsScope.reload)"
                >
                    <div class="kgr-row">
                        <kgr-member-settings-form
                            :error="error"
                            :member-settings="numberRangeSettings.memberSettings"
                            :club-id="clubId"
                            class="animated fadeIn"
                            @enter="updateSettings(numberRangeSettingsScope.reload)"
                        />
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                    <div class="kgr-row">
                        <kgr-invoice-number-config-form
                            :error="error"
                            :invoice-number-config="numberRangeSettings.invoiceNumberConfig"
                            :invoice-count="invoiceCount"
                            :biggest-invoice-number-length="numberRangeSettings.biggestInvoiceNumberLength"
                            :club-id="clubId"
                            class="animated fadeIn"
                            @enter="updateSettings(numberRangeSettingsScope.reload)"
                        />
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                    <div class="kgr-row">
                        <kgr-accounts-receivable-number-config-form
                            :error="error"
                            :accounts-receivable-number-config="numberRangeSettings.accountsReceivableNumberConfig"
                            :club-id="clubId"
                            class="animated fadeIn"
                            @enter="updateSettings(numberRangeSettingsScope.reload)"
                        />
                    </div>
                    <hr class="kgr-separator kgr-separator--light" />
                    <div class="kgr-row">
                        <kgr-mandate-reference-number-config-form
                            :error="error"
                            :mandate-reference-number-config="numberRangeSettings.mandateReferenceNumberConfig"
                            :invoice-count="invoiceCount"
                            :club-id="clubId"
                            class="animated fadeIn"
                            @enter="updateSettings(numberRangeSettingsScope.reload)"
                        />
                    </div>
                </kgr-form-scaffold>
            </kgr-number-range-settings-provider>
        </kgr-invoice-count-provider>
    </div>
</template>

<script>
import AccountsReceivableNumberConfigForm from '../../components/club/settings/AccountsReceivableNumberConfigForm';
import ClubRepository from '../../js/repository/ClubRepository';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import InvoiceCount from '../../js/dto/InvoiceCount';
import InvoiceCountProvider from '../../components/data-provider/InvoiceCountProvider';
import InvoiceNumberConfigForm from '../../components/club/settings/InvoiceNumberConfigForm';
import MandateReferenceNumberConfigForm from '../../components/club/settings/MandateReferenceNumberConfigForm';
import MemberSettingsForm from '../../components/club/settings/MemberSettingsForm';
import NumberRangeSettings from '../../js/dto/NumberRangeSettings';
import NumberRangeSettingsProvider from '../../components/data-provider/NumberRangeSettingsProvider';

export default {
    components: {
        'kgr-member-settings-form': MemberSettingsForm,
        'kgr-invoice-count-provider': InvoiceCountProvider,
        'kgr-number-range-settings-provider': NumberRangeSettingsProvider,
        'kgr-invoice-number-config-form': InvoiceNumberConfigForm,
        'kgr-accounts-receivable-number-config-form': AccountsReceivableNumberConfigForm,
        'kgr-mandate-reference-number-config-form': MandateReferenceNumberConfigForm,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        isEditable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            error: new Error(),
            numberRangeSettings: new NumberRangeSettings(),
            invoiceCount: new InvoiceCount(),
        };
    },
    methods: {
        onNumberRangeSettingsLoaded(loadedNumberRangeSettings) {
            this.numberRangeSettings = loadedNumberRangeSettings;
        },
        onInvoiceCountLoaded(loadedInvoiceCount) {
            this.invoiceCount = loadedInvoiceCount;
        },
        updateSettings(reload) {
            if (!this.isEditable) {
                return;
            }
            this.pending = true;
            this.error = new Error();

            ClubRepository.updateNumberRangeSettings(this.clubId, this.numberRangeSettings)
                .then(() => {
                    reload();
                    this.$notify.success('saveChanges.success');
                    this.pending = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
